import React from 'react';

/**
 * User Avatar Component
 * Displays user's initials in a circular avatar
 */
const UserAvatar = ({ name, size = 'default', className = '' }) => {
  const getInitials = (fullName) => {
    if (!fullName) return 'U';
    
    const parts = fullName.trim().split(' ');
    if (parts.length === 1) {
      return parts[0].charAt(0).toUpperCase();
    }
    
    // Get first letter of first name and first letter of last name
    const firstInitial = parts[0].charAt(0).toUpperCase();
    const lastInitial = parts[parts.length - 1].charAt(0).toUpperCase();
    
    return `${firstInitial}${lastInitial}`;
  };

  const sizeClasses = {
    small: 'w-8 h-8 text-xs',
    default: 'w-10 h-10 text-sm',
    large: 'w-12 h-12 text-base'
  };

  const initials = getInitials(name);

  return (
    <div 
      className={`${
        sizeClasses[size]
      } rounded-full bg-gradient-to-br from-purple-500 to-blue-600 flex items-center justify-center text-white font-semibold shadow-md ${
        className
      }`}
      title={name}
    >
      {initials}
    </div>
  );
};

export default UserAvatar;
